import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '@gumtree/ui-library/src/pagination/pagination';
import ResultsList from '@gumtree/ui-library/src/results-list';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { PageLayout } from '@gumtree/shared/src/types/srp';

import {
    NumberOfItems,
    SellerAdsFlexContainer,
    SellerAdsMainContainer,
    Title,
} from './sellerads.style';
import StickyAdsColumn from './components/sticky-ads-column';
import { SelleradsState } from './reducers';

const App = () => {
    const { sellersOtherAds, pagePath, numberOfPages, numFound, currentPage, createdBy } =
        useSelector(selectState);

    return (
        <SellerAdsMainContainer>
            <Title {...qaAttribute('seller-title')}>
                Ads by {createdBy ? createdBy : 'this seller'}
            </Title>
            <NumberOfItems {...qaAttribute('total-ads-found')}>{numFound} items</NumberOfItems>
            <SellerAdsFlexContainer>
                <div>
                    <ResultsList ads={sellersOtherAds} pageLayout={PageLayout.OneColumn} />
                    <Pagination
                        currentPage={currentPage}
                        numberOfPages={numberOfPages}
                        pagePath={pagePath}
                        paginationSize={4}
                    />
                </div>
                <StickyAdsColumn />
            </SellerAdsFlexContainer>
        </SellerAdsMainContainer>
    );
};

export function selectState({
    sellerAds,
    sellerPagination: { pagePath, currentPage, numberOfPages },
}: SelleradsState) {
    return {
        pagePath,
        currentPage,
        numberOfPages,
        ...sellerAds,
    };
}

export default App;
